import React from 'react';
import { withRouter } from 'react-router';
import autoBind from 'react-autobind';
import ClientOinStore from '../stores/ClientOinStore';
import ClientOinActions from '../actions/ClientOinActions';
import Constants from '../constants/SelectCustomerConstants';
import TextInput from './Common/TextInput.jsx';
import Transitions from '../core/Transitions';
import SlidingSessionNotification from './SlidingSessionNotification.jsx';
import OmnitureTracking from '../utils/OmnitureTracking.js';

function getState() {
    return {
        productId: ClientOinStore.getProductId(),
        clientOin: ClientOinStore.getClientOin(),
        errorList: ClientOinStore.getErrorList(),
        canForward: ClientOinStore.getCanForwardFromClientOin()
    };
}

class ClientOin extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = getState();
    }

    componentDidMount() {
        ClientOinStore.addChangeListener(this._onChange);
        OmnitureTracking.getTrackingEnabled();
    }

    componentWillUnmount() {
        ClientOinStore.removeChangeListener(this._onChange);
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextState.canForward) {
            ClientOinActions.setClientOin(this.state.clientOin);
            Transitions.forwardFromClientSelect(this.props.router, { productId: this.state.productId });
        }
    }

    _onChange() {
        this.setState(getState());
    }

    _onNext() {
        ClientOinActions.forwardFromClientOin();
    }

    _onClientOinChange(event) {
        ClientOinActions.updateClientOin(event.target.value);
    }

    render() {
        var field = Constants.ClientOin;
        return (
            <div className="start">
                <div className="container">
                    <SlidingSessionNotification />
                    <h2>Client OIN</h2>
                    <div className="row">
                        <div className="col-md-4 col-md-offset-4">
                            <TextInput id={field.id}
                                value={this.state.clientOin}
                                placeholder={field.placeholder}
                                className="form-text"
                                onBlur={this._onClientOinChange}
                                model={field.model}
                                maxLength={field.maxLength}
                                errorList={this.state.errorList} />
                            <p></p>
                            <p><a className="btn btn-default btn-block btn-lg" onClick={this._onNext}>Next</a></p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(ClientOin)


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ClientOin.jsx